<app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

<div class="mx-auto p-4 bg-gradient-to-br from-gray-50 to-white font-sans">
  <div class="flex items-center gap-3 mb-2">
    <div
      class="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
      </svg>
    </div>
    <div>
      <h1 class="text-2xl font-bold text-gray-900">Payment History</h1>
      <!-- <p class="text-gray-600 text-sm">Where should we send your order?</p> -->
    </div>
  </div>
  <div class="h-1 w-24 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full"></div>
</div>
<!-- <div class="mt-8">
  <div class="mb-6">
    <h2 class="text-2xl md:text-3xl font-bold text-gray-800 relative inline-block">
      Payment History
      <span class="absolute bottom-0 left-0 w-1/2 h-1 bg-gradient-to-r from-green-500 to-teal-600 rounded-full"></span>
    </h2>
    <div class="h-1 mt-2 bg-gradient-to-r from-green-200 via-teal-200 to-cyan-200 rounded-full"></div>
  </div>
</div> -->

<div *ngIf="dataSource?.data?.length > 0; else noData" class="w-[98%] mx-auto py-2">

  <!-- Grid Layout: 1 card on mobile, 2-3 on tablet, 4-5 on desktop -->
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">

    <!-- Transaction Card -->
    <div *ngFor="let element of dataSource.data"
      class="bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 overflow-hidden group">

      <!-- Card Header Gradient -->
      <div class="h-2 bg-gradient-to-r from-green-400 to-teal-500"></div>

      <!-- Card Content -->
      <div class="p-4">

        <!-- Date & Time - Prominent -->
        <div class="flex items-center justify-between mb-3">
          <div class="flex items-center space-x-2">
            <div class="bg-green-100 p-2 rounded-lg group-hover:bg-green-200 transition-colors">
              <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
              </svg>
            </div>
            <span class="text-xs font-medium text-gray-500">TRANSACTION</span>
          </div>
          <!-- Status Badge -->
          <span [ngClass]="{
            'px-3 py-1.5 rounded-full text-xs font-medium shadow-sm': true,
            'bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 border border-green-200': element.transactionsStatus === 'Success' || element.transactionsStatus === 'Completed',
            'bg-gradient-to-r from-yellow-100 to-amber-100 text-yellow-800 border border-yellow-200': element.transactionsStatus === 'Pending' || element.transactionsStatus === 'Processing',
            'bg-gradient-to-r from-red-100 to-rose-100 text-red-800 border border-red-200': element.transactionsStatus === 'Failed' || element.transactionsStatus === 'Cancelled',
            'bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-800 border border-blue-200': element.transactionsStatus === 'Refunded'
          }">
            {{ element.transactionsStatus }}
          </span>
        </div>

        <!-- Amount - Large & Bold -->
        <div class="mb-4 pb-3 border-b border-gray-100">
          <span class="text-xs text-gray-500 uppercase tracking-wider">Amount</span>
          <div class="flex items-baseline">
            <span class="text-2xl font-bold text-gray-800">{{ element.amount | currency: 'INR' }}</span>
            <span class="ml-2 text-xs text-gray-400">INR</span>
          </div>
        </div>

        <!-- Transaction Details Grid -->
        <div class="space-y-3">

          <!-- Transaction ID -->
          <div class="flex items-start">
            <div class="w-6 flex-shrink-0">
              <svg class="w-4 h-4 text-gray-400 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z">
                </path>
              </svg>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-xs text-gray-500">Transaction ID</p>
              <p class="text-sm font-mono font-medium text-gray-800 truncate" title="{{ element.transactionId }}">
                {{ element.transactionId }}
              </p>
            </div>
          </div>

          <!-- Bank Transaction ID -->
          <div class="flex items-start">
            <div class="w-6 flex-shrink-0">
              <svg class="w-4 h-4 text-gray-400 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10">
                </path>
              </svg>
            </div>
            <div class="flex-1 min-w-0">
              <p class="text-xs text-gray-500">Bank Transaction ID</p>
              <p *ngIf="element.bankTransactionId && element.bankTransactionId !== 'null'"
                class="text-sm font-mono text-gray-800 truncate" title="{{ element.bankTransactionId }}">
                {{ element.bankTransactionId }}
              </p>
              <p *ngIf="!element.bankTransactionId || element.bankTransactionId === 'null'"
                class="text-sm text-gray-400 italic flex items-center">
                <svg class="w-3.5 h-3.5 mr-1 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636">
                  </path>
                </svg>
                Not Available
              </p>
            </div>
          </div>

          <!-- Date & Time -->
          <div class="flex items-start pt-2 mt-1 border-t border-gray-50">
            <div class="w-6 flex-shrink-0">
              <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <div class="flex-1">
              <p class="text-xs text-gray-500">Date & Time</p>
              <p class="text-xs text-gray-700 font-medium">
                {{ element.dateAndTime | date: 'dd MMM yyyy, HH:mm' }}
              </p>
              <p class="text-xs text-gray-400">
                {{ element.dateAndTime | date: 'EEEE' }}
              </p>
            </div>
          </div>

        </div>

        <!-- Payment Method Placeholder (if available in your data) -->
        <!-- <div *ngIf="element.paymentMethod" class="mt-3 pt-2 border-t border-gray-100">
          <div class="flex items-center">
            <svg class="w-4 h-4 text-gray-400 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
            </svg>
            <span class="text-xs text-gray-600">{{ element.paymentMethod }}</span>
          </div>
        </div> -->

      </div>

      <!-- Card Footer with subtle action -->
      <div class="bg-gray-50/50 px-4 py-2 border-t border-gray-100 text-right">
        <span class="text-xs text-gray-400 inline-flex items-center">
          <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          Transaction ID: {{ element.transactionId.slice(-8) }}
        </span>
      </div>

    </div>

  </div>

  <!-- Summary Footer -->
  <div
    class="mt-6 p-4 bg-gradient-to-r from-green-50 to-teal-50 rounded-xl border border-green-100 flex flex-wrap items-center justify-between">
    <div class="flex items-center space-x-4">
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      </div>
      <div>
        <p class="text-xs text-gray-600">Total Transactions</p>
        <p class="text-lg font-bold text-gray-800">{{ dataSource?.data?.length }}</p>
      </div>
    </div>
    <div class="flex items-center space-x-2">
      <span class="text-xs text-gray-500">Last updated:</span>
      <span class="text-xs font-medium text-gray-700">{{ dataSource?.data[0]?.dateAndTime | date: 'dd MMM yyyy'
        }}</span>
    </div>
  </div>

</div>

<!-- No Data Template -->
<ng-template #noData>
  <div class="w-[98%] mx-auto py-8">
    <div
      class="bg-gradient-to-br from-gray-50 to-gray-100/50 rounded-2xl p-8 text-center border border-dashed border-gray-300">
      <div class="inline-flex items-center justify-center w-20 h-20 bg-gray-200 rounded-full mb-4">
        <svg class="w-10 h-10 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z">
          </path>
        </svg>
      </div>
      <h3 class="text-xl font-semibold text-gray-800 mb-2">No Transactions Found</h3>
      <p class="text-gray-600 mb-6 max-w-md mx-auto">You haven't made any transactions yet. Your payment history will
        appear here once you make your first purchase.</p>
      <button
        class="inline-flex items-center px-6 py-3 bg-gradient-to-r from-green-500 to-teal-600 hover:from-green-600 hover:to-teal-700 text-white font-medium rounded-lg shadow-md hover:shadow-lg transition-all duration-200">
        <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
        </svg>
        Browse Products
      </button>
    </div>
  </div>
</ng-template>

<!-- Alternative Compact Card Style (if you want even more cards per row) -->
<!-- Uncomment below and comment the main grid if you need 5-6 cards per row -->
<!-- 
<div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
  <div *ngFor="let element of dataSource.data" class="bg-white rounded-lg shadow-sm border border-gray-100 p-3 hover:shadow transition-all">
    <div class="flex justify-between items-start mb-2">
      <span class="text-xs font-medium text-gray-400">#{{ element.transactionId.slice(-6) }}</span>
      <span [ngClass]="{
        'px-2 py-0.5 rounded-full text-xs': true,
        'bg-green-100 text-green-700': element.transactionsStatus === 'Success',
        'bg-yellow-100 text-yellow-700': element.transactionsStatus === 'Pending',
        'bg-red-100 text-red-700': element.transactionsStatus === 'Failed'
      }">{{ element.transactionsStatus }}</span>
    </div>
    <div class="text-lg font-bold text-gray-800 mb-1">{{ element.amount | currency: 'INR' }}</div>
    <div class="text-xs text-gray-500 truncate">{{ element.dateAndTime | date: 'dd MMM yyyy' }}</div>
  </div>
</div>
-->

<!-- Custom Styles (add to your global CSS or component styles) -->
<style>
  /* Smooth hover effects */
  .transaction-card-hover {
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  }

  .transaction-card-hover:hover {
    transform: translateY(-2px);
  }

  /* Custom scrollbar for any overflow areas */
  .custom-scrollbar::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 4px;
  }

  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #a0aec0;
  }

  /* Animation for new transactions */
  @keyframes slideIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-slideIn {
    animation: slideIn 0.3s ease-out;
  }
</style>